import React, {useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Statistic, Divider, Button } from 'antd';
import { TeamOutlined, CalendarOutlined, MergeCellsOutlined } from '@ant-design/icons';
import { motion } from 'motion/react';
import _ from 'lodash';
import AddStageParticipant from '../../components/AddStageParticipant';
import { dateFormat } from '../../utils';
import RankingTable from '../../components/RankingTable';
import ParticipantTable from '../../components/ParticipantTable';
import WaitlistTable from '../../components/WaitlistTable';
import * as Setting from '../../utils/AuthUtils';
import SubscribeStage from '../../components/SubscribeStage';
import UpdateStage from '../../components/UpdateStage';
import { MeContext } from '../../context/';


function Stage(props) {
  const [loading, setLoading] = useState(false)
  const [editable, setEditable] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false);
  const [hasRights, setHasRights] = useState({isAdmin: false, isReferral: false});
  const [isRegistered, setIsRegistered] = useState({registered: false, info: null});
  const [width, setWidth] = useState(window.innerWidth);
  const me = useContext(MeContext);
  // console.warn('props di stage: ',props);

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }

  useEffect(() => {
    setIsAdmin(me && me.payLoad ? me.payLoad.isAdmin : false);
    const rights = {isAdmin: false, isReferral: false};
    const lref = (props.stage && props.stage.payLoad && props.stage.payLoad ? props.stage.payLoad.seasonInfo.hostingLeague.referrerId : 0 )
    const cdref = (props.stage && props.stage.payLoad && props.stage.payLoad ? props.stage.payLoad.seasonInfo.hostingLeague.casdoorId : '' )
    rights.isAdmin = me && me.payLoad ? me.payLoad.isAdmin : false;
    rights.isReferral = ((me && me.payLoad && (me.payLoad.p_id === lref || me.payLoad.u_id === cdref)) ? true : false);
    setHasRights(rights)
    // console.warn('sono permessi ho?', hasRights);
    // console.warn('stato di me:', me);
    if (me && me.payLoad) {
      // console.warn('devo verificare se sono registrato alla tappa:', props.id, me.payLoad.stagesSubscribed);
      if (me.payLoad.stagesSubscribed && me.payLoad.stagesSubscribed.length > 0 && me.payLoad.stagesSubscribed.includes(parseInt(props.id))) {
        const stageInfo = _.filter(me.payLoad.stagesSubscribedInfo, {'id': parseInt(props.id)})
        // console.warn('sono registrato:', isRegistered);
        setIsRegistered({registered: true, info: stageInfo});
      }
    }
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, [props, me])
  
  /* useEffect(() => {
     Setting.getUserinfo()
        .then(
          (result) => {
            setIsAdmin(result.payLoad.isAdmin);
            const rights = {isAdmin: false, isReferral: false};
            const lref = (props.stage && props.stage.payLoad && props.stage.payLoad ? props.stage.payLoad.seasonInfo.hostingLeague.referrerId : 0 )
            const cdref = (props.stage && props.stage.payLoad && props.stage.payLoad ? props.stage.payLoad.seasonInfo.hostingLeague.casdoorId : '' )
            rights.isAdmin = result.payLoad.isAdmin;
            rights.isReferral = ((result.payLoad.p_id === lref || result.payLoad.u_id === cdref) ? true : false);
            setHasRights(rights)
            // console.warn('sono permessi ho?', hasRights);
            if (result && result.payLoad) {
              if (result.payLoad.stageSubscribed && result.payLoad.stagesSubscribed.length > 0 && result.payLoad.stagesSubscribed.includes(parseInt(props.id))) {
                const stageInfo = _.filter(result.payLoad.stagesSubscribedInfo, {'id': parseInt(props.id)})
                setIsRegistered({registered: true, info: stageInfo});
                // console.warn('sono registrato:', isRegistered);
              }
            }
          },
          (error) => {
            console.warn(error);
            setIsAdmin(false);
          }
        ) 
  }, [props]) */

  function toggleEditable(e) {
    e.preventDefault();
    if (editable) {
      setEditable(false)
    } else {
      setEditable(true)
    }
  }

  function generateStageName(stage) {
    if (stage && stage.seasonInfo) {
      return <p>{stage.name} - <a href={`/seasons/${stage.seasonInfo.id}`}>{stage.seasonInfo.name}</a></p>;
    }
    return '';
  }

  // const title = (props.stage.value && props.stage.value.payLoad !== null ? props.stage.value.payLoad.name : "");
  const participants = (props.participants && props.participants.payLoad !== null ? props.participants.payLoad : []);
  const waitlist = (props.waitlist && props.waitlist.payLoad !== null ? props.waitlist.payLoad : [])
  const stage = (props.stage && props.stage.payLoad !== null ? props.stage.payLoad : {});
  const isMobile = width <= 768;
  const cardClassName = ( isMobile ? 'card-mobile' : '');
  if (stage.isDone === true || editable) {
    return (
      <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
      <Card className={cardClassName} loading={props.pending || loading} title={generateStageName(stage)} style={{ marginTop: '24px' }}>
        <Row gutter={16} justify="center">
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <Statistic title="Date" value={dateFormat(stage.date)} prefix={<CalendarOutlined />} />
          </Col>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <Statistic title="Rounds" value={stage.turns} prefix={<MergeCellsOutlined />} />
          </Col>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <Statistic title="Players" value={`${stage.playerAttendancy} (cap: ${stage.playerCap})`} prefix={<TeamOutlined />}/>
          </Col>
        </Row >
        <Row justify="center">
          { Setting.isLoggedIn() && !stage.isDone &&
            <Col xs={24} sm={24} md={6} lg={6} xl={6}><SubscribeStage onSubscribe={props.subscribe} stageId={stage.id} registrationInfo={isRegistered} /></Col>
          }
          { Setting.isLoggedIn() && isAdmin && !stage.isDone && 
            <Col xs={24} sm={24} md={6} lg={6} xl={6}><AddStageParticipant onAddPlayer={props.addPlayer} stageId={stage.id}/></Col>
          }
          { Setting.isLoggedIn() && stage.canEdit && stage.isDone &&
            <Col xs={24} sm={24} md={6} lg={6} xl={6}><UpdateStage onEditStage={props.editStage} stage={stage}/></Col>
          }
        </Row>
        <Divider>Stage Ranking</Divider>
        <Row justify="center">
          <Col span={24}>
            {
              Setting.isLoggedIn() && (isAdmin || hasRights.isReferral) && stage.isDone !== true && stage.playerAttendancy > 0 && editable === false &&
              <Row justify="center">
                <Col xs={24} sm={24} md={6} lg={6} xl={6}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">UPDATE RANKING</Button></Col>
              </Row>
            }
            {
              Setting.isLoggedIn() && (isAdmin || hasRights.isReferral) && stage.isDone === true && editable === false &&
              <Row justify="center">
                <Col xs={24} sm={24} md={6} lg={6} xl={6}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">EDIT RANKING</Button></Col>
              </Row>
            }
            <RankingTable showConfirm admin={isAdmin} hasRights={hasRights} editing={editable} toggleEditing={toggleEditable} dataSource={participants} mobile={isMobile} {...props} />
          </Col>
        </Row>
      </Card>
      </motion.div>
    );
  }
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
    <Card className={cardClassName} loading={props.pending || loading} title={generateStageName(stage)} style={{ marginTop: '24px' }}>
        <Row gutter={16} justify="center">
          <Col span={8}>
            <Statistic title="Date" value={dateFormat(stage.date)} prefix={<CalendarOutlined />} />
          </Col>
          <Col span={8}>
            <Statistic title="Rounds" value={stage.turns} prefix={<MergeCellsOutlined />} />
          </Col>
          <Col span={8}>
            <Statistic title="Players" value={`${stage.playerAttendancy} (cap: ${stage.playerCap})`} prefix={<TeamOutlined />}/>
          </Col>
        </Row >
        <Row justify="center">
          { Setting.isLoggedIn() && !stage.isDone &&
            <Col span={8}><SubscribeStage onSubscribe={props.subscribe} stageId={stage.id} registrationInfo={isRegistered} /></Col>
          }
          { Setting.isLoggedIn() && (isAdmin || hasRights.isReferral) && !stage.isDone && 
            <Col span={8}><AddStageParticipant onAddPlayer={props.addPlayer} stageId={stage.id}/></Col>
          }
          { Setting.isLoggedIn() && (isAdmin || hasRights.isReferral) && !stage.isDone && 
            <Col span={8}><UpdateStage onEditStage={props.editStage} stage={stage}/></Col>
          }
        </Row>
        <Divider>Players</Divider>
        {
          Setting.isLoggedIn() && (isAdmin || hasRights.isReferral) && stage.isDone !== true && editable === false &&
          <Row justify="center">
            <Col xs={12} sm={12} md={8} lg={8} xl={8}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">UPDATE RANKING</Button></Col>
            { (isAdmin || hasRights.isReferral) &&
              <Col xs={12} sm={12} md={8} lg={8} xl={8}><Link to={`/stages/${stage.id}/import-results`}><Button style={{ marginBottom: 16 }} type="primary">IMPORT RESULTS</Button></Link></Col>
            }
          </Row>
        }
        {
          Setting.isLoggedIn() && (isAdmin || hasRights.isReferral) && stage.isDone === true && editable === false &&
          <Row justify="center">
            <Col span={4}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">EDIT RANKING</Button></Col>
          </Row>
        }
        <Row>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} style={{padding: '10px'}}>
            <ParticipantTable admin={isAdmin} rights={hasRights} editing={editable} toggleEditing={toggleEditable} dataSource={participants} mobile={isMobile} {...props} />
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} style={{padding: '10px'}}>
            <WaitlistTable admin={isAdmin} rights={hasRights} editing={editable} toggleEditing={toggleEditable} dataSource={waitlist} mobile={isMobile} {...props} />
          </Col>
        </Row>
      </Card>
      </motion.div>
  );
}

export default Stage;
// export default Domanda;